export default "__VITE_ASSET__5e458736__"